/**
 * Temporary one-off control for the US2119019 Group 2 foundation diagnostic: the button, its caption and the result line.
 * Replaced by the assistant panel work in US2105994. Not a pattern for new features.
 */

// externals
import React from 'react';

// libraries
import { Button } from '@interstate/components/Button';
import { Typography } from '@interstate/components/Typography';

// hooks
import type { DiagnosticState } from './useAssistantDiagnostic';
import { useAssistantDiagnostic } from './useAssistantDiagnostic';

// styles
import { DiagnosticCaption, DiagnosticResult, DiagnosticWrapper } from './AssistantConnectionDiagnostic.style';

const resultText = (state: DiagnosticState): string => {
    switch (state.status) {
        case 'pending':
            return 'Checking…';
        case 'success':
            return `Connection verified · ${state.stage} · ${state.buildId} · request ${state.requestId}`;
        case 'error':
            return `Check failed · ${state.code} · request ${state.requestId ?? '—'}`;
        default:
            return '';
    }
};

export const AssistantConnectionDiagnosticControl = () => {
    const { state, run } = useAssistantDiagnostic();

    return (
        <DiagnosticWrapper data-testid="assistant-diagnostic">
            <div>
                <Button
                    data-testid="assistant-diagnostic-button"
                    buttonStyle="secondary"
                    size="small"
                    disabled={state.status === 'pending'}
                    onClick={() => {
                        void run();
                    }}
                >
                    Test assistant connection
                </Button>
                <DiagnosticCaption>
                    <Typography variant="body-xs" color="sem.color.on-surface.muted">
                        Non-production diagnostic; requires the dealer's inventory assistant setting.
                    </Typography>
                </DiagnosticCaption>
            </div>
            <DiagnosticResult data-testid="assistant-diagnostic-result" aria-live="polite">
                <Typography variant="body-sm" tag="span">
                    {resultText(state)}
                </Typography>
            </DiagnosticResult>
        </DiagnosticWrapper>
    );
};
